

import Accounts from "./Accounts";


class Dashboard extends Accounts{
    constructor(params) {
      super(params);
    this.isView = false;
    this.accountLabel = "Dashboard";
    this.accountType = "Dashboard";
    this.generic.accountType = "Dashboard";
    this.isParent = true;
    this.account = "Dashboard";
    this.role = (params.assigned) ? "assigned" : params.assignee ? "assignee" : "owner";
  this.setParameters(params);
  this.setConfiguration((params.configuration) ? params.configuration : {});
    }
  
    setParameters(params){
      for (var prop in params){
          if (params.hasOwnProperty(prop)){
              var method = "set" + prop.charAt(0).toUpperCase() + prop.slice(1);
              if (this[method]){
                  this[method](params[prop]);
              }
              
          }
      }
    }

    setConfiguration(o){
      if (o.dashboardSettings){
        for (var z of Object.keys(o.dashboardSettings)){
          this.dashboardSettings[z] = o.dashboardSettings[z];
        }
      }
      if (o.name){
      this.setName(o.name);
      this.setDisplayName(o.name);
      }
      if (o.description){
        this.setDescription(o.description);
      }
      if (o.accesses){
        o.access = o.accesses.map((a) => {
          return a.nickname;
        });
      }
        this.isAdminDashboard = (o.access && o.access.indexOf("admin") > -1) ? true : false;
        this.configuration = o;
        
    }
    setName(val){
      this.name = val;
      this.generic.name = val;
    }
    setDescription(val){
      this.description = val;
      this.generic.description = val;
    }
    setDisplayName(val){
      this.displayName = val;
      this.generic.label = val;
    }
    setUser_email(o){
      this.generic.subTitle = o.value;
    }

 
    setNetwork(n){
      this.network = n;
      this.generic.network = n;
      this.isView = n.group && n.group == 'Defaults' ? true : this.isView;
    }
    setDashboardType(val){
      this.dashboardType = val;
      this.generic.label = val;
    }
    setDashboardId(val){
      this.dashboardId = val;
    }
    setAccesses(arr){
      this.access = [];
        this.access = arr.map((a)=>{return a.nickname.toLowerCase();});
        if (this.role == 'owner'){this.isOwned = true;}
        if (this.access.indexOf("assignee") > -1 && this.role == 'assigned'){this.isShared = true;}
        if (this.access.indexOf("assignee") > -1 && this.role == 'assignee'){this.isBorrowed = true;}
    }
    setDocumentId(val){
      this.documentId = val;
      this.platformId = val;
      this.id = val;
    }
    setDomain(val){
      this.domain = (val && val != '') ? val : 'custom';
      this.generic.url = '';
    }
    setDashboardSettings(json){
      this.dashboardSettings = json;
    }
    setMetrics(arr){
      this.Metric = arr;
    }
}

export default Dashboard;
  